import { creatorbase } from '@round/api';
import { Table } from '@round/creatorbase-ui';
import styles from './ErrorsTable.module.css';

const ISSUE_LABEL = 'Not a recognised profile URL';

type Props = {
    lines: creatorbase.ClassifiedLine[];
};

const ErrorsTable = ({ lines }: Props) => (
    <Table.Container className={styles.container}>
        <Table>
            <Table.Header className={styles.header}>
                <Table.Row>
                    <Table.Head>Input</Table.Head>
                    <Table.Head>Issue</Table.Head>
                </Table.Row>
            </Table.Header>

            <Table.Body>
                {lines.map((line, index) => (
                    <Table.Row key={`${line.line}-${index}`}>
                        <Table.Cell className={styles.input} title={line.line}>
                            {line.line}
                        </Table.Cell>
                        <Table.Cell className={styles.issue}>{ISSUE_LABEL}</Table.Cell>
                    </Table.Row>
                ))}
            </Table.Body>
        </Table>
    </Table.Container>
);

export default ErrorsTable;
